/* Mendly free-gift guard.
 *
 * The $0 subscriber gift bundle is added alongside a subscription. Nothing stopped
 * a customer removing the coffee and checking out with a free mug + whisk, so this
 * ties the gift to a qualifying line:
 *
 *   - no qualifying subscription line in the cart  -> the gift is removed
 *   - gift quantity above 1                        -> clamped back to 1
 *   - checkout submitted with a gift-only cart     -> blocked, gift stripped
 *
 * Runs on every page because the cart drawer is site-wide. Client-side, so it is a
 * guard rather than a hard server-side rule - a determined user with devtools can
 * still post to /cart/add.js directly. A bulletproof version needs a Shopify
 * Function, which this store's custom app cannot deploy.
 */
(function () {
  var GIFT_VARIANT = 43431751516208;
  var QUALIFYING_PRODUCTS = [7775247171632];      // Mushroom Coffee Starter Kit
  var busy = false;

  var getCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  };

  /** A line earns the gift only if it's a qualifying product on a subscription. */
  function qualifies(item) {
    return QUALIFYING_PRODUCTS.indexOf(item.product_id) !== -1 && !!item.selling_plan_allocation;
  }

  function refreshCartUI() {
    if (location.pathname.indexOf('/cart') === 0) {
      location.reload();
      return Promise.resolve();
    }
    return fetch('/?section_id=cart-drawer-section', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var host = document.getElementById('shopify-section-cart-drawer-section');
        var next = new DOMParser().parseFromString(html, 'text/html')
          .getElementById('shopify-section-cart-drawer-section');
        if (host && next) {
          var wasOpen = (document.getElementById('cart-drawer') || {}).hasAttribute
            ? document.getElementById('cart-drawer').hasAttribute('open') : false;
          host.replaceWith(next);
          if (wasOpen) {
            var d = document.getElementById('cart-drawer');
            if (d && typeof d.open === 'function') d.open();
          }
        }
      })
      .catch(function () { /* a stale drawer is better than a broken one */ });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  /** Returns a promise resolving true when it had to change something. */
  function enforce() {
    if (busy) return Promise.resolve(false);
    return getCart().then(function (cart) {
      var gift = null;
      var earned = false;
      cart.items.forEach(function (item) {
        if (item.variant_id === GIFT_VARIANT) gift = item;
        else if (qualifies(item)) earned = true;
      });
      if (!gift) return false;
      if (earned && gift.quantity === 1) return false;

      busy = true;
      return changeLine(gift.key, earned ? 1 : 0)
        .then(refreshCartUI)
        .then(function () { return true; })
        .catch(function () { return false; })
        .then(function (changed) { busy = false; return changed; });
    }).catch(function () { return false; });
  }

  // Re-render churn in the drawer can fire the observer many times in a row. Throttle
  // the observer path so a busy cart can't spam /cart.js and earn a 429.
  var lastCheck = 0;
  var timer = null;
  function scheduleEnforce() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var now = Date.now();
      if (now - lastCheck < 1500) return;
      lastCheck = now;
      enforce();
    }, 400);
  }

  // 1. every page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enforce);
  } else {
    enforce();
  }

  // 2. whenever the drawer or cart re-renders after a quantity change or removal
  var observer = new MutationObserver(scheduleEnforce);
  function watch() {
    ['shopify-section-cart-drawer-section', 'cart-drawer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
    var main = document.querySelector('.cart-items-component, cart-items-component');
    if (main) observer.observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  // 3. the one that actually matters - never let a gift-only cart reach checkout
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart') === -1) return;
    if (!form.querySelector('[name="checkout"], #checkout')) return;
    if (form.dataset.mendlyChecked === '1') return;

    event.preventDefault();
    event.stopPropagation();
    getCart().then(function (cart) {
      var hasGift = cart.items.some(function (i) { return i.variant_id === GIFT_VARIANT; });
      var earned = cart.items.some(qualifies);
      if (hasGift && !earned) {
        return enforce().then(function () {
          window.alert('The free Mug & Whisk come with a Mendly subscription. Add a subscription to your cart to unlock them.');
        });
      }
      form.dataset.mendlyChecked = '1';
      form.submit();
    }).catch(function () {
      form.dataset.mendlyChecked = '1';
      form.submit();
    });
  }, true);
})();
